import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=1fed0f22&scoped=true"
import script from "./TicketComments.vue?vue&type=script&lang=js"
export * from "./TicketComments.vue?vue&type=script&lang=js"
import style0 from "./TicketComments.vue?vue&type=style&index=0&id=1fed0f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fed0f22",
  null
  
)

export default component.exports